import _ from "lodash";
import React from "react";
import {
  ToggableDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "./Dropdown";

import IconYes from "../../../assets/images/icon_yes.svg";
import IconNo from "../../../assets/images/icon_no.svg";

export default ({ filter, onChange }) => {
  const value = filter ? filter.value : null;

  return (
    <ToggableDropdown className="status-dropdown">
      <DropdownToggle caret>
        {value === null && <span>Status</span>}
        {value === "none" && <span>None</span>}
        {value === "true" && <img src={IconYes} />}
        {value === "false" && <img src={IconNo} />}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onChange(null)}>None</DropdownItem>
        <DropdownItem onClick={() => onChange("true")}>
          <img src={IconYes} />
        </DropdownItem>
        <DropdownItem onClick={() => onChange("false")}>
          <img src={IconNo} />
        </DropdownItem>
      </DropdownMenu>
    </ToggableDropdown>
  );
};



// WEBPACK FOOTER //
// ./src/components/Table/FlagFilter.js